import { InfoIcon } from '@chakra-ui/icons';
import {
  ButtonGroup,
  Button as ChakraButton,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Tag,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import Body2 from '@components/typography/Body2';
import { useRef } from 'react';
import { titleCase } from 'title-case';

const QuotingPopover = ({ hidden, header, handleClick, body, bodyTwo }) => {
  const initialFocusRef = useRef();
  const { onClose } = useDisclosure();
  const [isLargerThan800] = useMediaQuery('(min-width: 800px)');
  return (
    <Popover initialFocusRef={initialFocusRef} placement="bottom-start" trigger="hover" onClose={onClose}>
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Tag
              as={ChakraButton}
              bgColor="#eaf5e7"
              hidden={hidden}
              size="md"
              maxW="10.5rem"
              py={0}
              h={3}
              _hover={{ bgColor: '#bbdfb1' }}
            >
              <Body2>{isLargerThan800 ? 'Excluded from Quote' : 'Excluded'}</Body2>
              <InfoIcon ml={1} />
            </Tag>
          </PopoverTrigger>
          <PopoverContent color="black" bg="mint" borderColor="mint.800">
            <PopoverHeader pt={4} fontWeight="bold" border="0">
              {titleCase(header)}
            </PopoverHeader>
            <PopoverCloseButton />
            <PopoverBody fontSize="md">
              <Body2>{body}</Body2>
              <Body2>{bodyTwo}</Body2>
            </PopoverBody>
            <PopoverFooter border="0" display="flex" alignItems="center" justifyContent="flex-start" pb={4}>
              <ButtonGroup size="sm">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => {
                    handleClick();
                    onClose();
                  }}
                >
                  Include
                </Button>
              </ButtonGroup>
            </PopoverFooter>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default QuotingPopover;
